import { useTranslation } from 'react-i18next'
import { Flap } from '@/components/ui/Flap'
import { cn } from '@/lib/utils'

type ScoreFlapsProps = {
  home: number | null
  away: number | null
  /** La dimensione si regola con `text-*`: le palette sono in `em`. */
  className?: string
}

const digits = (value: number) =>
  String(value)
    .split('')
    .map((char, i) => <Flap key={i} char={char} />)

/**
 * Punteggio in cifre tabellari: quando cambia, la cifra entra in dissolvenza. Per lettori di schermo e test resta
 * il testo "4 – 1"; senza punteggio (partita da giocare) scrive "vs" in corsivo.
 */
export function ScoreFlaps({ home, away, className }: ScoreFlapsProps) {
  const { t } = useTranslation()
  if (home === null || away === null) {
    return <span className={cn('font-display text-[1.2em] italic leading-none', className)}>{t('zambePong.match.vs')}</span>
  }
  return (
    <span className={cn('inline-flex items-center gap-[0.18em] font-body font-semibold leading-none tabular-nums', className)}>
      <span className="sr-only">{`${home} – ${away}`}</span>
      <span aria-hidden="true" className="flex gap-[0.06em]">{digits(home)}</span>
      <span aria-hidden="true" className="opacity-50">:</span>
      <span aria-hidden="true" className="flex gap-[0.06em]">{digits(away)}</span>
    </span>
  )
}
